import(/* webpackMode: "eager", webpackExports: ["EdTechProductListTabLayout"] */ "/app/apps/next/app/(tabs)/products/products.tsx");
